export default (eventType) => ({
    eventType,
    currentMonth: new Date().getMonth(),
    currentYear: new Date().getFullYear(),
    monthNames: [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ],
    displayedMonth: new Date().getMonth(),
    displayedYear: new Date().getFullYear(),
    days: [],
    events: {},

    init() {
        this.updateDays();
        this.fetchEvents();
    },

    async fetchEvents() {
        try {
            const response = await fetch(`/wp-json/my-api/events?month=${this.displayedMonth + 1}&year=${this.displayedYear}&type=${this.eventType}`);            const data = await response.json();
            this.events = data.reduce((acc, event) => {
                const eventDateParts = event.event_date.split('/');
                const eventDate = new Date(
                    parseInt(eventDateParts[2], 10),
                    parseInt(eventDateParts[1], 10) - 1,
                    parseInt(eventDateParts[0], 10)
                );
                const day = eventDate.getDate();
    
                if (!acc[day]) acc[day] = [];
                acc[day].push(event);
    
                return acc;
            }, {});
    
            this.updateDays();
        } catch (error) {
            console.error("Failed to fetch events:", error);
        }
    },

    updateDays() {
        const firstDay = new Date(this.displayedYear, this.displayedMonth, 1).getDay();
        const daysInMonth = new Date(this.displayedYear, this.displayedMonth + 1, 0).getDate();

        this.days = [
            ...Array(firstDay).fill(null),
            ...Array.from({ length: daysInMonth }, (_, i) => i + 1)
        ];
    },

    nextMonth() {
        if (this.displayedMonth === 11) {
            this.displayedMonth = 0;
            this.displayedYear++;
        } else {
            this.displayedMonth++;
        }
        this.events = {};
        this.fetchEvents();
        this.updateDays();
    },
    
    prevMonth() {
        if (this.displayedYear === this.currentYear && this.displayedMonth <= this.currentMonth) {
            return;
        }
    
        if (this.displayedMonth === 0) {
            this.displayedMonth = 11;
            this.displayedYear--;
        } else {
            this.displayedMonth--;
        }
        this.events = {}; 
        this.fetchEvents(); 
        this.updateDays();
    },

    get displayedMonthName() {
        return this.monthNames[this.displayedMonth];
    }
});
